import React from 'react';

export interface IconDiamondFullProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconDiamondFull: React.FC<IconDiamondFullProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M7.57373 8.62811H16.4282L12.0013 21L7.57373 8.62811Z" fill={fill || "#020617"} /> <path fillRule="evenodd" clipRule="evenodd" d="M16.4281 7.49347H7.57367L12.0012 3L16.4281 7.49347Z" fill={fill || "#020617"} /> <path fillRule="evenodd" clipRule="evenodd" d="M6.49479 7.49347H1L5.43269 3H10.9275L6.49479 7.49347Z" fill={fill || "#020617"} /> <path fillRule="evenodd" clipRule="evenodd" d="M11 21.0001L6.49479 8.62811H1L11 21.0001Z" fill={fill || "#020617"} /> <path fillRule="evenodd" clipRule="evenodd" d="M17.5051 7.49347H22.9999L18.5672 3H13.0724L17.5051 7.49347Z" fill={fill || "#020617"} /> <path fillRule="evenodd" clipRule="evenodd" d="M13 21.0001L17.5052 8.62811H23L13 21.0001Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconDiamondFull;
